export const getRootDataStore: any = (key: string) => JSON.parse(sessionStorage.getItem(key) ?? `{}`);
export const setRootDataStore: any = (data: any, key: string) => sessionStorage.setItem(key, JSON.stringify(data ?? {}));
export const clearRootDataStore: any = (key: string) => sessionStorage.removeItem(key);

export const mobile_decl_storage_keys = ["decl_sr", "mobile_income_tax"];